/*
for faster builds:
- 0. compile with TYPESCRIPT_TRANSPILE_ONLY=true in config/webpack/environment.js
- 1. import index_fast in this file
- 2. Multiple.vue -> remove Custom, Spreadsheet and Performance panels
- 3. src/editor/index.ts -> load registers_mini
- 4. test.ts -> comment all
- 5. @polygonjs/polygonjs/src/engine/poly/registers/nodes/All.ts -> load mini modules
*/

import '../src/engine/index';
// import '../src/engine/index_fast';
